import { useContext } from "react";
import styled, { css } from "styled-components";

import { IonIcon } from "@ionic/react";
import {
  basketOutline,
  calendarOutline,
  chatboxEllipsesOutline,
  colorPaletteOutline,
  gridOutline,
  imagesOutline,
  lockOpenSharp,
  storefrontOutline,
} from "ionicons/icons";
import { useNavigate, useOutletContext } from "react-router";
import { devices } from "../../../Devices";
import { isCartazFormat } from "../../../services/Utils.js";
import Button from "../../sharable/ActionButton.jsx";
import PremiumTag from "../../sharable/PremiumTag.jsx";
import WorkspaceContext from "../WorkspaceContext.js";
import BrandMenuView from "./BrandMenuView/BrandMenuView.jsx";
import CaptionMenuView from "./CaptionMenuView/CaptionMenuView.jsx";
import DateMenuView from "./DateMenuView/DateMenuView.jsx";
import GridMenuView from "./GridMenuView/GridMenuView.jsx";
import ProductMenuTab from "./ProductsMenuView/ProductMenuTab.jsx";
import PricesMenuView from "./StylesMenuView/PricesMenuView.jsx";
import StylesMenuView from "./StylesMenuView/StylesMenuView.jsx";
import ModelsMenuView from "./ThemesMenuView.jsx/ModelsMenuView.jsx";

export const PRODUCTS_VIEW = "0";
export const BRAND_VIEW = "1";
export const MODELS_VIEW = "2";
export const STYLES_VIEW = "3";
export const PRICE_VIEW = "4";
export const GRID_VIEW = "5";
export const PRODUCT_LAYOUT_VIEW = "6";
export const DATE_VIEW = "7";
export const MY_PRODUCTS_VIEW = "8";
export const CAPTION_VIEW = "9";

const Container = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  background-color: #171717;
  color: #ecfeff;
  position: relative;
  overflow-x: auto;

  @media ${devices.laptop} {

    grid-template-columns: 1fr;
    grid-template-rows: min-content; 1fr;
  }

    @media ${devices.laptop} {
    grid-template-columns: 1fr
    grid-template-rows: 1fr min-content;
    grid-row: 2/3;
    
  }
`;

const MenuItem = styled.ul`
  border-bottom: 1px solid #171717;
  text-transform: capitalize;
  font-size: 1.4rem;
  padding: 2.4rem 1.2rem;
  cursor: pointer;
  width: 100%;
  text-align: center;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  line-height: 1rem;
  .tab-icon {
    font-size: 2.4rem;
  }

  ${({ currentMenuView }) =>
    currentMenuView &&
    css`
      color: #d97706;
      background-color: #171717;
      font-weight: bold;
    `}

  position: relative;
  p {
    white-space: nowrap;
  }
`;
const Menu = styled.li`
  height: calc(100vh - 8.4rem);
  overflow-y: scroll;
  list-style: none;
  background-color: #0a0a0a;
  border-bottom-right-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: auto;
  max-width: 100vw;
  @media ${devices.laptop} {
    flex-direction: row;
  }
  @media ${devices.laptop} {
    width: 100%;
    flex-direction: row;
    height: min-content;
    grid-row: 2/3;

    ${MenuItem} {
      border-bottom: none;
      border-right: 1px solid #171717;
      min-width: 10rem;

      background-color: #0a0a0a !important;
    }
  }
`;

export const MenuDescription = styled.span`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  display: inline-block;
`;

const MenuView = styled.div`
  padding: 2rem;
`;

export const MenuTitle = styled.h1`
  font-size: 3rem;
  font-family: "Titillium Web", sans-serif;
  grid-column: 1/-1;
  margin-bottom: 1.4rem;
  text-transform: capitalize;
`;

const Soon = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #d97706;
  font-size: 1rem;
  transform: rotate(45deg);
  padding: 0.2rem 0.4rem;
  color: #fff;
  z-index: 2;
`;

const EditPermissionMessage = styled.p`
  width: 100%;
  text-align: center;
  font-size: 1.4rem;
  display: block;
  margin-top: 2rem;
  padding: 4.8rem 2rem;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

//COMPONENT VERIFIED 31/05;
export default function Toolbar() {
  const {
    currentMenuView,
    setCurrentMenuView,
    styles,
    menuRef,
    userHasAccessToLoadedModel,
  } = useContext(WorkspaceContext);
  const { activeAccount, isAccountPremium, accountStatus } = useOutletContext();
  const navigate = useNavigate();
  return (
    <Container>
      <Menu>
        <MenuItem
          className="item"
          currentMenuView={currentMenuView === PRODUCTS_VIEW}
          onClick={() => {
            setCurrentMenuView(PRODUCTS_VIEW);
          }}
        >
          <IonIcon icon={basketOutline} className="tab-icon" />
          Produtos
        </MenuItem>

        <MenuItem
          currentMenuView={currentMenuView === STYLES_VIEW}
          className="item"
          onClick={() => {
            setCurrentMenuView(STYLES_VIEW);
          }}
        >
          <IonIcon icon={colorPaletteOutline} className="tab-icon" />
          estilo
        </MenuItem>

        {!isCartazFormat(styles.format) && (
          <MenuItem
            currentMenuView={currentMenuView === GRID_VIEW}
            className="item"
            onClick={() => {
              setCurrentMenuView(GRID_VIEW);
            }}
          >
            <IonIcon icon={gridOutline} className="tab-icon" />
            <p>Grade de</p> produtos
            {accountStatus?.onTrial && <PremiumTag position={"top-center"} />}
          </MenuItem>
        )}
        <MenuItem
          currentMenuView={currentMenuView === MODELS_VIEW}
          className="item"
          onClick={() => {
            setCurrentMenuView(MODELS_VIEW);
          }}
        >
          <IonIcon icon={imagesOutline} className="tab-icon" />
          Temas
        </MenuItem>

        <MenuItem
          currentMenuView={currentMenuView === DATE_VIEW}
          className="item"
          onClick={() => {
            setCurrentMenuView(DATE_VIEW);
          }}
        >
          <IonIcon icon={calendarOutline} className="tab-icon" />
          Validade
        </MenuItem>

        <MenuItem
          currentMenuView={currentMenuView === BRAND_VIEW}
          className="item"
          onClick={() => {
            setCurrentMenuView(BRAND_VIEW);
          }}
        >
          <IonIcon icon={storefrontOutline} className="tab-icon" />
          Marca
        </MenuItem>

        <MenuItem
          currentMenuView={currentMenuView === CAPTION_VIEW}
          className="item"
          onClick={() => {
            setCurrentMenuView(CAPTION_VIEW);
          }}
        >
          <IonIcon icon={chatboxEllipsesOutline} className="tab-icon" />
          Legenda
        </MenuItem>
      </Menu>

      {(activeAccount || accountStatus?.onTrial) &&
      userHasAccessToLoadedModel ? (
        <MenuView isAccountPremium={isAccountPremium} ref={menuRef}>
          {currentMenuView === PRODUCTS_VIEW ? (
            <ProductMenuTab />
          ) : currentMenuView === DATE_VIEW ? (
            <DateMenuView />
          ) : currentMenuView === BRAND_VIEW ? (
            <BrandMenuView />
          ) : currentMenuView === MODELS_VIEW ? (
            <ModelsMenuView />
          ) : currentMenuView === STYLES_VIEW ? (
            <StylesMenuView />
          ) : currentMenuView === PRICE_VIEW ? (
            <PricesMenuView />
          ) : currentMenuView === CAPTION_VIEW ? (
            <CaptionMenuView />
          ) : (
            <GridMenuView />
          )}
        </MenuView>
      ) : !activeAccount && !accountStatus?.onTrial ? (
        <EditPermissionMessage>
          Escolha um plano para conseguir editar este encarte. Você ainda pode
          baixar este encarte :)
          <Button
            text={"renovar plano"}
            action={() => navigate("/planos")}
            icon={<IonIcon icon={lockOpenSharp} />}
          />
        </EditPermissionMessage>
      ) : (
        !userHasAccessToLoadedModel && (
          <EditPermissionMessage>
            Este encarte utiliza um tema premium, você não pode editar. Faça
            upgrade para um plano premium para desbloquear todos os temas!
            <Button
              text={"desbloquear temas"}
              action={() => navigate("/planos")}
              icon={<IonIcon icon={lockOpenSharp} />}
            />
          </EditPermissionMessage>
        )
      )}
    </Container>
  );
}
